module.exports = __webpack_public_path__ + "static/img/8.439d54b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/eng/8.png
// module id = Vx0L
// module chunks = 0